import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, DialogContent } from '@mui/material';
import { ShareForm } from './share-form.tsx';
import { ShareHeader } from './share-header.tsx';

interface ShareModalProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  selectedPropertyId?: string;
}

export const ShareModal = (props: ShareModalProps) => {
  const { isOpen, setIsOpen, selectedPropertyId } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    setIsOpen(false);
  };

  const headerTitle = () => {
    return 'Share Listing';
  };

  return (
    <>
      <Dialog
        data-testid="share-modal"
        className="auth-dialog"
        fullScreen={fullScreen}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="share-dialog-title"
      >
        <Box
          className="container"
          sx={{ minWidth: { xs: 'initial', sm: '600px' } }}
        >
          <ShareHeader setIsOpen={setIsOpen} title={headerTitle()} />
          <DialogContent className="content">
            {
              <ShareForm
                setIsOpen={setIsOpen}
                selectedPropertyId={selectedPropertyId || ''}
              />
            }
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
